import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LayoutComponent } from "../layout/layout.component";
import { SignedInGuard } from "./auth/services/signed-in-guard.service";
import { SignedOutGuard } from "./auth/services/signed-out-guard.service";

const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () => import("./home/home.module").then(module => module.HomeModule),
    canActivate: [SignedOutGuard],
  },
  {
    path: "home",
    redirectTo: "",
  },
  {
    path: "quem-somos",
    component: LayoutComponent,
    loadChildren: () => import("./quem-somos/quem-somos.module").then(module => module.QuemSomosModule),
    canActivate: [SignedOutGuard],
  },
  {
    path: "koortimativa",
    component: LayoutComponent,
    loadChildren: () => import("./koortimativa/koortimativa.module").then(module => module.KoortimativaModule),
    canActivate: [SignedOutGuard],
  },
  {
    path: "ferramenta",
    component: LayoutComponent,
    loadChildren: () => import("./ferramenta/ferramenta.module").then(module => module.FerramentaModule),
    canActivate: [SignedOutGuard],
  },
  {
    path: "auth",
    component: LayoutComponent,
    loadChildren: () => import("./auth/auth.module").then(module => module.AuthModule),
    canActivate: [SignedOutGuard],
  },
  {
    path: "user-menu",
    component: LayoutComponent,
    loadChildren: () => import("./user-menu/user-menu.module").then(module => module.UserMenuModule),
    canActivate: [SignedInGuard],
  },
  {
    path: "ajuda",
    component: LayoutComponent,
    loadChildren: () => import("./ajuda/ajuda.module").then(module => module.AjudaModule),
    canActivate: [SignedInGuard],
  },
  {
    path: "relatorio",
    component: LayoutComponent,
    loadChildren: () => import("./relatorio/relatorio.module").then(module => module.RelatorioModule),
    canActivate: [SignedInGuard],
  },
  {
    path: "dashboard",
    component: LayoutComponent,
    loadChildren: () => import("./dashboard/dashboard.module").then(module => module.DashboardModule),
    canActivate: [SignedInGuard],
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })
  ],
  exports: [RouterModule],
})
export class DomainsRoutingModule { }
